import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const store = {
  namespaced: true,

  state: {
    contacts: {},
    // key is "username"
    users: {},
    filter: {
      name: null
    }
  },
  mutations,
  actions,
  getters
};

export default store;
